import React from "react";

function ErrorMessage() {
  return (
    <div className="text-center">
      <span className="border-red p-4 text-center">
        ⚠️ Something went wrong! Please Try again!
      </span>
    </div>
  );
}

export default ErrorMessage;
